import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import {
  Col,
  Row,
  Form,
} from 'reactstrap'
import FormField from 'components/common/FormField'
import { StyledButton } from 'components/common/PrimaryButton'
import styled from 'styled-components'
import colors from 'constants/colors'
import { useSession } from 'components/auth/Session'
import { Redirect } from 'react-router-dom'
import { useLoading } from 'components/common/Loading'
import { Cognito } from 'components/auth/Cognito'
import { GoogleButton } from 'components/auth/GoogleButton'

const SubmitButton = styled(StyledButton)`
  background-color: #53C8A4;
  border: 0;
  &:hover {
    background-color: ${colors.green};
    border-color: ${colors.green};
  }
  &:focus {
    background-color: ${colors.green};
    border-color: ${colors.green};
  }
  &:active {
    background-color: ${colors.green} !important;
    border-color: ${colors.green} !important;
  }
`

const ErrorMessage = styled.div`
  font-family: Poppins;
  font-weight: 500;
  font-size: 12px;
  color: ${colors.error};
`

type FormData = {
  email: string
  password: string
}

export function Login() {
  const session = useSession()
  const { withLoading } = useLoading()
  const [submissionErrors, setSubmissionErrors] = useState<Error[] | null>(null)
  const { handleSubmit, register, errors } = useForm<FormData>()

  if (session.user) {
    return <Redirect to="/" />
  }

  const onSubmit = withLoading(async (data: FormData) => {
    try {
      const user = await Cognito.signIn({
        username: data.email,
        password: data.password,
      })
      session.login(user)
    } catch (err) {
      setSubmissionErrors([err])
    }
  })

  return (
    <>
      <Row>
        <Col xs="12">
          <h3 className="mb-3"> Welcome to Bird Level </h3>

          <GoogleButton title="Login with Google" />

          <hr className="mt-4 mb-4" />

          <p> or Login with your email </p>

          <Form onSubmit={handleSubmit(onSubmit)}>
            {submissionErrors?.map((err) => <ErrorMessage>{err.message}</ErrorMessage>)}

            <FormField
              placeholder="Email"
              name="email"
              type="text"
              feedback={errors.email?.message}
              innerRef={register({
                min: 0,
                required: 'Email is required',
              })}
              invalid={Boolean(errors.email)}
            />
            <FormField
              placeholder="Password"
              name="password"
              type="password"
              feedback={errors.password?.message}
              innerRef={register({
                minLength: {
                  value: 8,
                  message: 'Password must be at least 8 characters',
                },
                required: 'Password is required',
              })}
              invalid={Boolean(errors.password)}
            />

            <SubmitButton
              className="pl-115 w-100"
            >
              Sign in
            </SubmitButton>
          </Form>

          <div className="mt-4">
            <p>Forgot your password? <a href="/auth/forgot">Reset it</a></p>
            <p>Need an account? <a href="/signup">Signup</a></p>
          </div>
        </Col>
      </Row>
    </>
  )
}
